

export const FETCH_ESIGNATURE_REQUEST = 'FETCH_ESIGNATURE_REQUEST';
export const FETCH_ESIGNATURE_REQUEST_COMPLETED = 'FETCH_ESIGNATURE_REQUEST_COMPLETED';
export const FETCH_ESIGNATURE_REQUEST_ERROR = 'FETCH_ESIGNATURE_REQUEST_ERROR';
export const FETCH_ESIGNATURE_RESET = 'FETCH_ESIGNATURE_RESET';

export const FETCH_ESIGNATURE_LIST_REQUEST = 'FETCH_ESIGNATURE_LIST_REQUEST';
export const FETCH_ESIGNATURE_LIST_REQUEST_COMPLETED = 'FETCH_ESIGNATURE_LIST_REQUEST_COMPLETED';
export const FETCH_ESIGNATURE_LIST_REQUEST_ERROR = 'FETCH_ESIGNATURE_LIST_REQUEST_ERROR';
export const FETCH_ESIGNATURE_LIST_RESET = 'FETCH_ESIGNATURE_LIST_RESET';

export const ADD_ESIGNATURE_INITIAL = 'ADD_ESIGNATURE_INITIAL';
export const ADD_ESIGNATURE_REQUEST = 'ADD_ESIGNATURE_REQUEST';
export const ADD_ESIGNATURE_REQUEST_COMPLETED = 'ADD_ESIGNATURE_REQUEST_COMPLETED';
export const ADD_ESIGNATURE_REQUEST_ERROR = 'ADD_ESIGNATURE_REQUEST_ERROR';

export const UPDATE_FILE_REQUEST = 'UPDATE_FILE_REQUEST';
export const UPDATE_FILE_REQUEST_COMPLETED = 'UPDATE_FILE_REQUEST_COMPLETED';
export const UPDATE_FILE_REQUEST_ERROR = 'UPDATE_FILE_REQUEST_ERROR';


// WEBPACK FOOTER //
// ./constants/esignaturedetails.js